import CustomButton from "./Button"

const DangerButton = ({ isSolid, ...props }) => {
  return (
    <CustomButton
      {...props}
      style={{
        border: !isSolid ? "1px solid #D92D20" : "none",
        color: !isSolid ? "#D92D20" : "#FFFFFF",
        fontWeight: "500",
        fontSize:14,
        borderRadius: 5,
        padding: isSolid ? "24px 32px" : undefined,
        backgroundColor: isSolid ? "#D92D20" : undefined,
      }}
    >
      {props.children}
    </CustomButton>
  )
}

export default DangerButton